var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-page',{attrs:{"actions":_vm.actions,"fields":_vm.fields,"texts":_vm.texts,"sort-by":"description"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }